<template>
    <div v-if="store.state.showingModal === 'swatch-edit'">
        <div class="fullscreen-block" v-if="store.state.currentScreen === 'menu'"></div>
        <div class="b3-modal" id="swatch-edit-panel">

            <div class="swatch-preview">
                <div :style="previewFillColor"></div>
                <img v-if="inner==='Inner Color'" :src="previewInsideColorSource">
                <img class="overlay" v-if="inner!=='Opaque'" :src="previewTransparencySource">
                <img :src="previewFinishSource">
                <div class="multiply" v-if="showSecondColor" :style="previewTintColor"></div>
                <img v-if="previewCornersSource" :src="previewCornersSource">
            </div>

            <div v-if="isNew" class="modal-title">{{t('new swatch','New Swatch')}}</div>
            <div v-else-if="isLibraryBead" class="modal-title">{{t('edit library bead','Edit Library Bead')}}</div>
            <div v-else class="modal-title">{{t('edit swatch dialog title','Edit Swatch')}}</div>

            <div class="move-swatch-buttons" v-show="isIOS">
                <img @click="moveSwatchDown" :src="getTexture('arrow')" alt="arrow">
                <img @click="moveSwatchUp" :src="getTexture('arrow_down')" alt="down arrow">
            </div>

            <div class="scrollable-area">
                <div v-if="isLibraryBead" class="edit-swatch-form-option">
                    <label>{{t('title','Title')}}</label>
                    <input type="text" v-model="title" maxlength="100">
                </div>
                <div class="edit-swatch-form-option">
                    <label>{{t('description','Description')}}</label>
                    <input type="text" v-model="description" maxlength="100">
                </div>
                <div v-if="isLibraryBead" class="edit-swatch-form-option">
                    <label>{{t('details','Details')}}</label>
                    <input type="text" v-model="details" maxlength="100">
                </div>
                <div v-if="!isLibraryBead" class="edit-swatch-form-option">
                    <label>{{t('symbol','Symbol')}}</label>
                    <input v-model="letterCode" type="text" class="swatchLetterCode" maxlength="1">
                </div>
                <div v-if="isLibraryBead" class="edit-swatch-form-option">
                    <label class="stock-title">{{t('stock','Stock')}}</label>
                    <span class="stock-clear-button" @pointerover="hover(0)" @pointerout="cancelHover" @click="clickStock(0)"></span>
                    <span class="tube-box">
                        <span class="stock-button" :style="stockStyle(1)" @pointerover="hover(1)" @pointerout="cancelHover" @click="clickStock(1)"></span>
                        <span class="stock-button" :style="stockStyle(2)" @pointerover="hover(2)" @pointerout="cancelHover" @click="clickStock(2)"></span>
                        <span class="stock-button" :style="stockStyle(3)" @pointerover="hover(3)" @pointerout="cancelHover" @click="clickStock(3)"></span>
                        <span class="stock-button" :style="stockStyle(4)" @pointerover="hover(4)" @pointerout="cancelHover" @click="clickStock(4)"></span>
                    </span>
                    <span class="tube-lid"></span>
                    <span class="tube-handle"></span>
                </div>
                <div class="edit-swatch-color-title">
                    {{t('color','Color')}}
                    <span
                        v-show="!colorInputEnabled"
                        @click="colorInputEnabled = true"
                        class="button mini-button"
                    >
                        #
                    </span>
                    <span v-show="colorInputEnabled">
                        #<input
                            type="text"
                            @input="processHexInput(false)"
                            v-model="hexIn"
                            :placeholder="t('enter hex code', 'Enter hex code')"
                            style="margin: 0 5px;"
                        >
                    </span>
                    <span
                        v-show="colorInputEnabled"
                        @click="colorInputEnabled = false"
                        class="button mini-button"
                    >
                        OK
                    </span>
                </div>

                <div class="hsl-slider-area top-area">
                    <input :style="hSliderStyle" min="0" max="360" type="range" v-model="hVal" class="slider h-slider">
                    <input :style="sSliderStyle" min="0" max="100" type="range" v-model="sVal" class="slider s-slider">
                    <input :style="lSliderStyle" min="0" max="100" type="range" v-model="lVal" class="slider l-slider">
                </div>

                <div v-show="!store.state.plasticMode">
                    <div class="edit-swatch-form-option">
                        <label>
                            {{t('add tint','Add tint')}}
                            <span v-show="showSecondColor">
                                <span
                                    v-show="!tint_colorInputEnabled"
                                    @click="tint_colorInputEnabled = true"
                                    class="button mini-button"
                                >
                                    #
                                </span>
                                <span v-show="tint_colorInputEnabled">
                                    #<input
                                        type="text"
                                        @input="processHexInput(true)"
                                        v-model="tint_hexIn"
                                        :placeholder="t('enter hex code', 'Enter hex code')"
                                        style="margin: 0 5px;"
                                    >
                                </span>
                                <span
                                    v-show="tint_colorInputEnabled"
                                    @click="tint_colorInputEnabled = false"
                                    class="button mini-button"
                                >
                                    OK
                                </span>
                            </span>
                        </label>
                        <input v-model="showSecondColor" type="checkbox">
                    </div>

                    <div class="hsl-slider-area" v-if="showSecondColor">
                        <input :style="tint_hSliderStyle" min="0" max="360" type="range" v-model="tint_hVal" class="slider h-slider">
                        <input :style="tint_sSliderStyle" min="0" max="100" type="range" v-model="tint_sVal" class="slider s-slider">
                        <input :style="tint_lSliderStyle" min="0" max="100" type="range" v-model="tint_lVal" class="slider l-slider">
                    </div>

                    <div class="edit-swatch-form-option">
                        <label>{{t('edit swatch finish','Finish')}}</label>
                        <span class="finish-picker-holder">
                            <img :class="finishName === 'Matte' ? 'selected' : ''" @click="chooseFinish('Matte')" :src="getFinish('matte')" class="finish-picker">
                            <img :class="finishName === 'Semi-Gloss' ? 'selected' : ''" @click="chooseFinish('Semi-Gloss')" :src="getFinish('semigloss')" class="finish-picker">
                            <img :class="finishName === 'Gloss' ? 'selected' : ''" @click="chooseFinish('Gloss')" :src="getFinish('gloss')" class="finish-picker">
                        </span>
                    </div>
                    <div id="swatch-edit-inner-div" class="edit-swatch-form-option">
                        <label>{{t('edit swatch transparency','Transparency')}}</label>
                        <span class="finish-picker-holder">
                            <img :class="inner === 'Opaque' ? 'selected' : ''" @click="chooseInner('Opaque')" :src="getFinish('matte')" class="finish-picker">
                            <img :class="inner === 'Transparent' ? 'selected' : ''" @click="chooseInner('Transparent')" :src="getFinish('transparent')" class="finish-picker overlay">
                            <img :class="inner === 'Inner Color' ? 'selected' : ''" @click="chooseInner('Inner Color')" :src="getFinish('insidecolor')" class="finish-picker overlay">
                        </span>
                    </div>
                </div>
            </div>
            <div class="edit-swatch-button-area">
                <button @click="addOrUpdateSwatch">{{t('edit swatch save button','Save')}}</button>
                <button @click="closeDialog">{{t('cancel','Cancel')}}</button>
                <button
                    v-if="!isLibraryBead"
                    class="warning-button"
                    @click="deleteSwatch"
                    :disabled="hasBeadsOnCanvas"
                >
                    {{t('delete swatch button','Delete')}}
                </button>
                <span v-if="isLibraryBead">
                    <button
                        v-if="!isCustom"
                        class="warning-button"
                        @click="resetSwatch"
                    >
                        {{t('reset swatch button', 'Reset')}}
                    </button>
                    <button
                        v-if="isCustom"
                        class="warning-button"
                        @click="resetSwatch"
                    >
                        {{t('delete swatch button', 'Delete')}}
                    </button>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { palette } from '../myapp/src/palette';
import { utils } from '../myapp/src/utils';
import { settings } from '../myapp/src/settings';
import { beadLibrary } from '../myapp/src/tools/beadLibrary';
import { modes } from '../myapp/src/modes';
import { isIOS } from '../myapp/src/core/environment';

export default {
    data() {
        return {
            hexIn: '',
            tint_hexIn: '',
            secondColor: '',
            letterCode: '',
            finishName: '',
            inner: '',
            description: '',
            title: '',
            details: '',
            id: '',
            isNew: false, // are we creating a new swatch?
            isLibraryBead: false,
            colorInputEnabled: false,
            tint_colorInputEnabled: false,
            hasBeadsOnCanvas: false,
            showSecondColor: false,
            hVal: 180,
            sVal: 50,
            lVal: 50,
            tint_hVal: 180,
            tint_sVal: 50,
            tint_lVal: 50,
            stock: 0,
            hoverStock: null,
            isIOS
        }
    },
    methods: {
        getTexture(texture) {
            return require(`../../public/images/${texture}.png`);
        },
        moveSwatchUp() {
            const source = this.store.state.swatches.find(element => element.id === this.id);
            if (!source) return;
            const cutLocation = this.store.state.swatches.indexOf(source);
            if (cutLocation === this.store.state.swatches.length - 1) return;
            const pasteLocation = cutLocation + 1;
            this.cutPaste(source, cutLocation, pasteLocation);
        },
        moveSwatchDown() {
            const source = this.store.state.swatches.find(element => element.id === this.id);
            if (!source) return;
            const cutLocation = this.store.state.swatches.indexOf(source);
            if (cutLocation === 0) return;
            const pasteLocation = cutLocation - 1;
            this.cutPaste(source, cutLocation, pasteLocation);
        },
        cutPaste(source, cutLocation, pasteLocation) {
            const swatchCopy = this.store.state.swatches.slice();
            swatchCopy.splice(cutLocation, 1);
            swatchCopy.splice(pasteLocation, 0, source);
            this.store.mySet('swatches', swatchCopy);
        },
        addOrUpdateSwatch() {
            const infix = this.store.state.libraryShape === 'cylinder' ? 'cylinder_' : '';
            const letterCode = this.letterCode === '' ? null : this.letterCode;
            const _color = this.hslToHex(this.hVal, this.sVal, this.lVal);
            const fillColor = parseInt('0x' + _color);
            const description = this.isLibraryBead ?
                this.description :
                this.description || utils.returnApproxColor(fillColor);
            const finishName = this.store.state.plasticMode ?
                'plastic':
                infix + palette.finishList.find(element => element.display === this.finishName).lower;
            const inner = this.store.state.plasticMode ?
                null:
                palette.innerList.find(element => element.display === this.inner).lower;
            const _secondColor = this.showSecondColor ?
                this.hslToHex(this.tint_hVal, this.tint_sVal, this.tint_lVal) : '';
            const secondColor = this.showSecondColor ? parseInt('0x' + _secondColor) : null;
            const isNew = this.isNew;
            const id = this.id;
            const title = this.title;
            const details = this.details;
            const stock = this.stock;
            const a = settings.library.index;
            const c = utils.hexTorgb(_color);

            const swatch = {
                letterCode, fillColor, description, finishName, inner,
                secondColor, isNew, id, title, details, stock, a, c
            };

            this.isLibraryBead ?
                this.updateLibraryBead(swatch):
                palette.addOrUpdateSwatch(swatch);
        },
        updateLibraryBead(swatch) {

            const fields = [
                'letterCode', 'fillColor', 'description', 'finishName', 'inner',
                'secondColor', 'title', 'details', 'stock', 'id'
            ].concat(this.isNew ? ['a', 'c'] : []);

            const savedSwatch = this.store.state.customBeads.find(s => s.id === swatch.id);
            if (savedSwatch) {
                fields.forEach(field => {
                    savedSwatch[field] = swatch[field];
                });
            } else {
                const newSwatch = {}
                fields.forEach(field => {
                    newSwatch[field] = swatch[field];
                });
                this.store.state.customBeads.push(newSwatch);
            }

            settings.preferences.customBeads = this.store.state.customBeads;
            settings.update();

            beadLibrary.updateEntry({swatch});
            this.store.mySet('showingModal', modes.currentMode.name === 'browser' ? null : 'library-modal');
        },
        deleteSwatch() {
            palette.deleteSwatchAndClose();
        },
        closeDialog() {
            this.isLibraryBead ?
                this.store.mySet('showingModal', modes.currentMode.name === 'browser' ? null : 'library-modal'):
                palette.closeSwatchDialog();
        },
        processHexInput(tint) {
            const prefix = tint ? 'tint_' : '';
            const hex = this[`${prefix}hexIn`];
            if (hex.length !== 6) return;
            if (/^[a-f0-9]+$/.test(hex)) this.setSlidersFromHex({hex, tint});
        },
        setSlidersFromHex({hex, tint}) {
            const prefix = tint ? 'tint_' : '';
            const [h, s, l] = this.hexTohsl(hex);
            this[`${prefix}hVal`] = h;
            this[`${prefix}sVal`] = s;
            this[`${prefix}lVal`] = l;
        },
        chooseFinish(str) {
            this.finishName = str;
        },
        chooseInner(str) {
            this.inner = str;
        },
        hexTohsl(hex) {
            return utils.hexTohsl(hex);
        },
        hslToHex(h, s, l) {
            return utils.hslToHex(h, s, l);
        },
        getFinish(str) {
            const prefix = this.store.state.libraryShape === 'cylinder' ? 'cylinder_' :
                ['insidecolor', 'insidecolor', 'transparent'].some(e => e === str) ?
                    'round_' : '';
            return require(`../../public/images/${prefix}${str}.png`);
        },
        resetSwatch() {
            this.store.mySet('customBeads', this.store.state.customBeads.filter(s => s.id !== this.id));

            if (this.id.slice(0, 3) === 'ZZZ') {
                const collections = this.store.state.collections;
                collections.forEach(c => {
                    c.beadIdList = c.beadIdList.filter(e => e !== this.id);
                });
                settings.preferences.collections = this.store.state.collections;
            }

            settings.preferences.customBeads = this.store.state.customBeads;
            settings.update();

            beadLibrary.resetEntry({id: this.id});

            this.store.mySet('showingModal', modes.currentMode.name === 'browser' ? null : 'library-modal');

            if (this.id.slice(0, 3) === 'ZZZ') {
                beadLibrary.displayBeads({method: 'filter'});
            }
        },
        clickStock(n) {
            this.stock = n;
        },
        hover(n) {
            this.hoverStock = n;
        },
        cancelHover() {
            this.hoverStock = null;
        },
        stockStyle(n) {
            const colors = ['black', 'red', 'chocolate', '#cccc00', '#33dd33'];
            const amount = this.hoverStock === null ? this.stock : this.hoverStock;
            const color = n === 0 ?
                this.hoverStock === 0 ? 'lightgray' : 'black' :
                n > amount ?
                    'lightgray' :
                    colors[amount];
            return `background-color: ${color};`;
        },
        resetUI() {
            this.colorInputEnabled = false;
            this.tint_colorInputEnabled = false;
            this.hexIn = '';
            this.tint_hexIn = '';
        }
    },
    computed: {
        isCustom: function () {
            return this.id.slice(0, 3) === 'ZZZ';
        },
        hex: function () {
            return this.hslToHex(this.hVal, this.sVal, this.lVal);
        },
        hSliderStyle: function () {
            const colors = new Array(7).fill('')
                .map((e, i) => `hsl(${i * 60}, ${this.sVal}%, ${this.lVal}%) ${(i * 100/6).toFixed()}%`)
                .join(', ');
            return `background: linear-gradient(to right, ${colors});`
        },
        sSliderStyle: function () {
            return `background: linear-gradient(to right, hsl(${this.hVal}, 0%, ${this.lVal}%) 0%, hsl(${this.hVal}, 100%, ${this.lVal}%) 100%);`;
        },
        lSliderStyle: function () {
            return `background: linear-gradient(to right, hsl(${this.hVal}, ${this.sVal}%, 0%) 0%, hsl(${this.hVal}, ${this.sVal}%, 50%) 50%, hsl(${this.hVal}, ${this.sVal}%, 100%) 100%);`;
        },
        tint_hSliderStyle: function () {
            const colors = new Array(7).fill('')
                .map((e, i) => `hsl(${i * 60}, ${this.tint_sVal}%, ${this.tint_lVal}%) ${(i * 100/6).toFixed()}%`)
                .join(', ');
            return `background: linear-gradient(to right, ${colors});`
        },
        tint_sSliderStyle: function () {
            return `background: linear-gradient(to right, hsl(${this.tint_hVal}, 0%, ${this.tint_lVal}%) 0%, hsl(${this.tint_hVal}, 100%, ${this.tint_lVal}%) 100%);`;
        },
        tint_lSliderStyle: function () {
            return `background: linear-gradient(to right, hsl(${this.tint_hVal}, ${this.tint_sVal}%, 0%) 0%, hsl(${this.tint_hVal}, ${this.tint_sVal}%, 50%) 50%, hsl(${this.hVal}, ${this.sVal}%, 100%) 100%);`;
        },
        previewFillColor: function () {
            return `background-color: hsl(${this.hVal}, ${this.sVal}%, ${this.lVal}%)`;
        },
        previewTintColor: function () {
            return `background-color: hsl(${this.tint_hVal}, ${this.tint_sVal}%, ${this.tint_lVal}%)`;
        },
        previewFinishSource: function () {
            if (this.store.state.plasticMode) return require(`../../public/images/plasticfinish.png`);
            const prefix = this.store.state.libraryShape === 'cylinder' ? 'cylinder_' : '';
            const finish = palette.finishList.find(element => element.display === this.finishName)?.lower || 'matte';
            return require(`../../public/images/${prefix}${finish}.png`);
        },
        previewCornersSource: function () {
            return this.store.state.libraryShape === 'round' ?
                require(`../../public/images/round_corners_offwhite.png`) : '';
        },
        previewInsideColorSource: function () {
            if (this.store.state.plasticMode) return '';
            if (this.inner !== 'Inner Color') return '';
            const prefix = this.store.state.libraryShape === 'cylinder' ? 'cylinder_' : 'round_';
            return require(`../../public/images/${prefix}insidecolor.png`);
        },
        previewTransparencySource: function () {
            if (this.store.state.plasticMode) return '';
            if (this.inner === 'Opaque') return '';
            const prefix = this.store.state.libraryShape === 'cylinder' ? 'cylinder_' : 'round_';
            return require(`../../public/images/${prefix}transparent.png`);
        }
    },
    mounted() {
        this.ee.on('editSwatch', swatch => {
            this.isLibraryBead = swatch.isLibraryBead;
            if (this.isLibraryBead) {
                this.title = swatch.title;
                this.details = swatch.details;
            }
            this.isNew = swatch.isNew;
            this.id = swatch.id;
            this.stock = swatch.stock;
            this.description = swatch.description;
            this.fillColor = utils.colorToHex(swatch.fillColor);
            this.setSlidersFromHex({hex: this.fillColor, tint: false});
            this.finishName = palette.finishList.find(element => element.lower === swatch.finishName).display;
            this.inner = palette.innerList.find(element => element.lower === swatch.inner)?.display || null;
            this.letterCode = swatch.letterCode || '';
            this.showSecondColor = !!swatch.secondColor;
            this.secondColor = this.showSecondColor ?
                utils.colorToHex(swatch.secondColor): '';
            if (this.showSecondColor) {
                this.setSlidersFromHex({hex: this.secondColor, tint: true});
            }
            this.hasBeadsOnCanvas = swatch.hasBeadsOnCanvas();
            this.resetUI();
        });
    }
}
</script>

<style lang="scss">
@import '../assets/colors.scss';

.fullscreen-block {
    background-color: #00000057;
    width: 100%;
    position: absolute;
    height: 1000%;
    z-index: 1;
}

#swatch-edit-panel {
    position: absolute;
    z-index: 1;
    border-radius: 5px;
    width: 370px;
    background-color: $off_white;
    top: 78px;
    left: 300px;
    box-shadow: 0 0 5px black;
    label {
        width: 145px;
    }
    .stock-title {
        position: relative;
        top: 12px;
        width: 100px;
    }
    .stock-clear-button {
        display: inline-block;
        position: relative;
        top: 0px;
        width: 23px;
        height: 16px;
        border: 2px solid lightgray;
        margin-right: 3px;
        &:hover {
            background-color: lightgray;
            cursor: pointer;
        }
    }
    .stock-button {
        display: inline-block;
        width: 25px;
        height: 20px;
        margin-right: 3px;
        &:hover {
            cursor: pointer;
        }
    }
    .tube-box {
        display: inline-block;
        border: 2px solid black;
        padding: 5px 2px 1px 4px;
    }
    .tube-lid {
        display: inline-block;
        height: 34px;
        width: 12px;
        background-color: black;
        position: relative;
        top: 7px;
    }
    .tube-handle {
        position: relative;
        top: 3px;
        left: -12px;
        display: inline-block;
        height: 20px;
        width: 15px;
        border-radius: 100%;
        border: 4px solid black;
    }
}

.move-swatch-buttons {
    position: absolute;
    top: 17px;
    left: 190px;
    img {
        opacity: 0.6;
        height: 38px;
        &:hover {
            opacity: 1;
            cursor: pointer;
        }
    }
}

.modal-title {
    font-size: 26px;
    padding: 20px;
}

.hsl-slider-area {
    width: 300px;
    .slider {
        -webkit-appearance: none;  /* Override default CSS styles */
        appearance: none;
        width: 100%; /* Full-width */
        height: 25px; /* Specified height */
        background: #d3d3d3; /* Grey background */
        outline: none; /* Remove outline */
    }

    .slider::-webkit-slider-thumb {
        -webkit-appearance: none; /* Override default look */
        appearance: none;
        width: 5px; /* Set a specific slider handle width */
        height: 25px; /* Slider handle height */
        background: black; /* Green background */
        cursor: pointer; /* Cursor on hover */
    }

    .slider::-moz-range-thumb {
        width: 5px; /* Set a specific slider handle width */
        height: 25px; /* Slider handle height */
        background: black; /* Green background */
        cursor: pointer; /* Cursor on hover */
    }
}

.swatch-preview {
    top: 10px;
    right: 10px;
    height: 45px;
    width: 56px;
    float: right;
    position: relative;
    div {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0px;
    }
    img {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0px;
    }
    .overlay {
        mix-blend-mode: overlay;
    }
    .multiply {
        mix-blend-mode: multiply;
    }
}

.edit-swatch-form-option {
    display: block;
    padding: 5px 0px;
    label {
        vertical-align: top;
    }
    input:not([type=checkbox]), select {
        width: 175px;
    }
}

.finish-picker {
  width: 25px;
  margin-right: 10px;
  background-color: lightgray;
  &.selected {
    background-color: $b_theme;
    box-shadow: 0 0 0 2px white;
  }
}

.scrollable-area {
    padding: 0 20px;
    max-height: 420px;
    overflow-y: auto;
}

.edit-swatch-button-area {
    padding: 20px;
    button {
        margin-right: 10px;
    }
}


</style>